import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { adminMainUrl } from "../../Config";
const ForgetEmail = () => {
    // const notify = () => toast("Wow so easy!");
    const navigate = useNavigate();
    const validationSchema = Yup.object({
        email: Yup.string()
            .email("Invalid email address")
            .required("Enter Your Email Address"),
    });
    const formik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                const response = await fetch(`${adminMainUrl}/api/forgot-password`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email: values.email }),
                });
                const data = await response.json();
                if (response.ok) {
                    toast.success(data?.otp);
                      navigate("/forget-otp", {
                        state: { email: values.email, otp: data?.otp },
                      }); // Redirect to OTP page
                } else {
                    toast.error(data?.msg);
                    const errorData = await response.json();
                    console.error("Error sending OTP:", errorData.message);
                }
            } catch (error) {
                console.error("Network error:", error);
            }
        },
    });
    return (
        <div className="account-page">
            <div className="main-wrapper">
                <div className="account-content">
                    <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden account-bg-03">
                        <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
                            <form
                                className="flex-fill"
                                onSubmit={formik.handleSubmit}
                            >
                                <div className="mx-auto mw-450">
                                    <div className="text-center mb-4">
                                        <img src="/assets/img/logo.png" className="img-fluid" alt="Logo" />
                                    </div>
                                    <div className="mb-4">
                                        <h4 className="mb-2 fs-20">Forgot Password?</h4>
                                        <p>
                                            If you forgot your password, well, then we’ll email you
                                            instructions to reset your password.
                                        </p>
                                    </div>
                                    <div className="mb-3">
                                        <label className="col-form-label">Email Address</label>
                                        <div className="position-relative">
                                            <span className="input-icon-addon">
                                                <i className="ti ti-mail" />
                                            </span>
                                            <input
                                                type="text"
                                                id="email"
                                                className="form-control"
                                                placeholder="Enter Email Address"
                                                name="email"
                                                value={formik.values.email}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                required
                                            />
                                        </div>
                                        {formik.touched.email && formik.errors.email ? (
                                            <div className="error">{formik.errors.email}</div>
                                        ) : null}
                                    </div>
                                    <div className="mb-3">
                                        <button type="submit" className="btn btn-primary w-100">
                                            Send OTP
                                        </button>
                                    </div>
                                    <div className="mb-3 text-center">
                                        <h6>
                                            Return to
                                            <Link to="/login" className="text-purple link-hover">
                                                Login
                                            </Link>
                                        </h6>
                                    </div>
                                    {/* <div className="form-set-login or-text mb-3">
                                        <h4>OR</h4>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center flex-wrap mb-3">
                                        <div className="text-center me-2 flex-fill">
                                            <a
                                                href="javascript:void(0);"
                                                className="br-10 p-2 px-4 btn bg-pending  d-flex align-items-center justify-content-center"
                                            >
                                                <img
                                                    className="img-fluid m-1"
                                                    src="assets/img/icons/facebook-logo.svg"
                                                    alt="Facebook"
                                                />
                                            </a>
                                        </div>
                                        <div className="text-center me-2 flex-fill">
                                            <a
                                                href="javascript:void(0);"
                                                className="br-10 p-2 px-4 btn bg-white d-flex align-items-center justify-content-center"
                                            >
                                                <img
                                                    className="img-fluid  m-1"
                                                    src="assets/img/icons/google-logo.svg"
                                                    alt="Facebook"
                                                />
                                            </a>
                                        </div>
                                        <div className="text-center flex-fill">
                                            <a
                                                href="javascript:void(0);"
                                                className="bg-dark br-10 p-2 px-4 btn btn-dark d-flex align-items-center justify-content-center"
                                            >
                                                <img
                                                    className="img-fluid  m-1"
                                                    src="assets/img/icons/apple-logo.svg"
                                                    alt="Apple"
                                                />
                                            </a>
                                        </div>
                                    </div> */}
                                    <div className="text-center">
                                        <p className="fw-medium text-gray">Copyright © 2024 - CRMS</p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ForgetEmail